// This is the entry point for the home component
import React, { FC, useCallback, useContext, useEffect } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Styling
import injectSheet from 'react-jss';

// Actions

// Components
import CheckBox from 'Components/CheckBox';

import { ProductAnalyticsContext } from 'Context/ProductAnalytics';

import { areEqualObjects } from 'Utils/areEqual';
import withErrorBoundary from 'HOC/ErrorBoundary';
import { setGenderValue } from './actions/gender.actions';
import styleSheet from './styles';

interface Props {
  classes: any;
  selectAllGender: any;
}

const Gender: FC<Props> = ({ classes, selectAllGender = undefined }: Props) => {
  const selector = useSelector(
    (selectors: any) => selectors.filter.demographics.gender,
    areEqualObjects
  );
  const dispatch = useDispatch();

  const {
    actions: { filterTrack },
  } = useContext(ProductAnalyticsContext);

  // Will be needed for future use.
  const { female, male, otherThirdGender } = selector;

  useEffect(() => {
    // The intial value will be undefined.  It will only be set to true or false, when
    // either the SelectAll or Clear button are clicked.
    if (selectAllGender !== undefined) {
      // Send events for each checkbox.
      filterTrack({
        filterCategory: 'Demographics',
        filterName: 'Gender.All',
        filterValue: selectAllGender,
        addToStore: selectAllGender,
      });
    }
  }, [selectAllGender]);

  // Will be needed for future use.
  const callback = (e: any) => {
    const { id } = e.target;

    // Combined Analytics Event
    filterTrack({
      filterCategory: 'Demographics',
      filterName: 'Gender',
      filterValue: id,
      addToStore: true,
    });
    setGenderValue(dispatch, selector[id], id);
  };

  return (
    <div className={classes.container}>
      <CheckBox
        label="Female"
        id="female"
        value={female}
        isChecked={female}
        onClick={useCallback(callback, [female])}
        overrideStyles={{ margin: '8px 0 17px' }}
      />
      <CheckBox
        label="Male"
        id="male"
        value={male}
        isChecked={male}
        onClick={useCallback(callback, [male])}
        overrideStyles={{ margin: '0 0 17px' }}
      />
      <CheckBox
        label="Non-Binary / Third Gender"
        id="otherThirdGender"
        value={otherThirdGender}
        isChecked={otherThirdGender}
        onClick={useCallback(callback, [otherThirdGender])}
        overrideStyles={{ margin: '0 0 8px' }}
      />
    </div>
  );
};

export default withErrorBoundary(injectSheet(styleSheet)(Gender));
